<template>
  <div class="">

    <Head />

    <div class="main" :class="getMainClass">

      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        :::
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ categoryTitle }}</li>
          </ol>
        </div>
      </nav>

      <!-- DisplayMode 1: 一般列表 (NewsList.vue) -->
      <div v-if="displayMode === 1" class="news_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ categoryTitle }}</h2>
          </div>

          <div class="box">
            <ul class="news_list">
              <li v-for="(item, index) in currentPageItems" :key="index">
                <a v-if="item.isExternal" class="news" :href="item.to" :target="item.target" :title="item.title + $t('（另開新視窗）')">
                  <p class="time">{{ item.time }}</p>
                  <p class="title">{{ item.title }}</p>
                </a>
                <router-link v-else class="news" :to="item.to" :title="item.title + $t('（另開新視窗）')" target="_blank">
                  <p class="time">{{ item.time }}</p>
                  <p class="title">{{ item.title }}</p>
                </router-link>
              </li>
            </ul>
          </div>

          <!-- 分頁頁碼 -->
          <div class="page_bg" v-if="pageCount > 1">
            <paginate v-model="currentPage" :pageCount="pageCount" :page-range="2" :margin-pages="2" :prevText="'<'"
              :nextText="'>'" :containerClass="'page_box'" :page-class="'page'" :prev-class="'prev'"
              :next-class="'next'" @input="onPageChange">
            </paginate>
          </div>

        </div>
      </div>

      <!-- DisplayMode 2: 圖文列表 (ActivityList.vue) -->
      <div v-if="displayMode === 2" class="activityList_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ categoryTitle }}</h2>
          </div>

          <div class="box">
            <ul class="activity_list row">
              <li class="col-12 col-md-6 col-xl-4" v-for="(item, index) in currentPageItems" :key="index">
                <a v-if="item.isExternal" class="activity" :href="item.to" :target="item.target" :title="item.title + $t('（另開新視窗）')">

                  <div class="img_box" :style="{ backgroundImage: `url(${item.src})` }">
                    <img :src="item.src" :alt="item.title">
                  </div>

                  <div class="text_box">
                    <p class="time">{{ item.time }}</p>
                    <div class="title">
                      <h3>{{ item.title }}</h3>
                    </div>
                  </div>
                </a>
                <router-link v-else class="activity" :to="item.to" :title="item.title + $t('（另開新視窗）')" target="_blank">

                  <div class="img_box" :style="{ backgroundImage: `url(${item.src})` }">
                    <img :src="item.src" :alt="item.title">
                  </div>

                  <div class="text_box">
                    <p class="time">{{ item.time }}</p>
                    <div class="title">
                      <h3>{{ item.title }}</h3>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>

          <!-- 分頁頁碼 -->
          <div class="page_bg" v-if="pageCount > 1">
            <paginate v-model="currentPage" :pageCount="pageCount" :page-range="2" :margin-pages="2" :prevText="'<'"
              :nextText="'>'" :containerClass="'page_box'" :page-class="'page'" :prev-class="'prev'"
              :next-class="'next'" @input="onPageChange">
            </paginate>
          </div>

        </div>
      </div>

      <!-- DisplayMode 3: 問與答 (Faq.vue) -->
      <div v-if="displayMode === 3" class="faq_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ categoryTitle }}</h2>
          </div>

          <div class="box">
            <ul class="faq_list">
              <li v-for="item in currentPageItems" :key="item.id" :class="['faq_li', { active: isAnswerOpen === item.id }]">
                <button class="faq_question" @click="toggleAnswer(item.id)">
                  <div class="add_icon">
                    <div class="line"></div>
                    <div class="line add"></div>
                  </div>
                  <p class="question">{{ item.question }}</p>
                </button>

                <div class="faq_answer_wrapper" :class="{ open: isAnswerOpen === item.id }">
                  <div class="faq_answer" v-if="isAnswerOpen === item.id">
                    <p class="answer" v-html="item.answer"></p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <!-- 分頁頁碼 -->
          <div class="page_bg" v-if="pageCount > 1">
            <paginate v-model="currentPage" :pageCount="pageCount" :page-range="2" :margin-pages="2" :prevText="'<'"
              :nextText="'>'" :containerClass="'page_box'" :page-class="'page'" :prev-class="'prev'"
              :next-class="'next'" @input="onPageChange">
            </paginate>
          </div>

        </div>
      </div>

      <!-- DisplayMode 4: 圖文列表(直接顯示內文) (ActivityList_2.vue) -->
      <div v-if="displayMode === 4" class="activityList_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ categoryTitle }}</h2>
          </div>

          <div class="box">
            <ul class="activity_list row">

              <li class="tab_box" v-if="isMobile">
                <div class="btn_box" v-for="(item, index) in allItems" :key="'tab-' + index">
                  <button :class="['tab_btn', { active: activeIndex === index }]" @click="activeIndex = index">
                    {{ item.title }}
                  </button>
                </div>
              </li>

              <li class="col-12" v-for="(item, index) in allItems" :key="index"
                v-show="!isMobile || activeIndex === index">

                <div class="activity">

                  <div class="img_box">
                    <img :src="item.src" :alt="item.title">
                  </div>

                  <div class="text_box">
                    <h3>{{ item.title }}</h3>
                    <p class="text" v-html="item.text"></p>
                  </div>

                </div>

              </li>
            </ul>
          </div>

        </div>
      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';

import AccesskeyLink from '@/views/AccesskeyLink.vue'

// 分頁頁碼
import Paginate from "vuejs-paginate";


export default {
  name: 'Category',
  components: {
    Head,
    Footer,

    AccesskeyLink,

    Paginate,
  },

  data() {
    return {
      categoryId: null,
      categoryTitle: '',
      displayMode: 1, // 1=一般列表, 2=圖文列表, 3=問與答, 4=圖文列表(直接顯示內文)
      
      allItems: [], // 所有項目
      currentPage: 1, // 當前頁碼
      itemsPerPage: 10, // 每頁項目數
      
      // FAQ 專用
      isAnswerOpen: null,
      
      // DisplayMode 4 專用
      activeIndex: 0,
      isMobile: false,
    };
  },

  computed: {
    // 根據 displayMode 返回對應的 class
    getMainClass() {
      switch (this.displayMode) {
        case 1:
          return 'newsList';
        case 2:
          return 'activityList';
        case 3:
          return 'faq';
        case 4:
          return 'activityList activityList_2';
        default:
          return '';
      }
    },

    // 計算總頁數
    pageCount() {
      if (this.displayMode === 4) {
        return 1; // DisplayMode 4 不分頁
      }
      return Math.ceil(this.allItems.length / this.itemsPerPage);
    },

    // 當前頁面的項目
    currentPageItems() {
      if (this.displayMode === 4) {
        return this.allItems; // DisplayMode 4 顯示所有項目
      }
      
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.allItems.slice(start, end);
    }
  },

  async mounted() {
    // 取得路由參數
    this.categoryId = this.$route.params.CId;
    
    if (this.categoryId) {
      await this.fetchCategoryData();
    }
    
    // DisplayMode 4 需要檢查裝置
    if (this.displayMode === 4) {
      this.checkDevice();
      window.addEventListener('resize', this.checkDevice);
    }
  },

  beforeDestroy() {
    if (this.displayMode === 4) {
      window.removeEventListener('resize', this.checkDevice);
    }
  },

  watch: {
    // 監聴路由變化
    '$route.params.CId': async function(newCId) {
      if (newCId) {
        this.categoryId = newCId;
        this.currentPage = 1; // 重置頁碼
        await this.fetchCategoryData();
      }
    },
    // 監聆語系變化
    '$i18n.locale': async function() {
      this.currentPage = 1;
      await this.fetchCategoryData();
    }
  },

  methods: {

    // 轉換前端語系名稱為後端格式
    convertLocaleForBackend(frontendLocale) {
      const localeMap = {
        'zh-TW': 'zh-tw',
        'en': 'en-us',
        'ja': 'ja-jp'
      };
      return localeMap[frontendLocale] || 'zh-tw';
    },
    // API: 取得分類資料
    async fetchCategoryData() {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        
        // 第一步：先取得基本資料以確定 displayMode
        let apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetCategoryData?CId=${this.categoryId}&IncludePost=false&locale=${backendLocale}`;
        let response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得分類資料，清空資料');
          this.categoryTitle = '';
          this.allItems = [];
          return;
        }
        
        const category = await response.json();
        
        // 設定分類標題和顯示模式
        this.categoryTitle = category.Title || '';
        this.displayMode = category.DisplayMode || 1;
        
        // 根據 displayMode 設定每頁項目數
        this.setItemsPerPage();
        
        // 第二步：根據 displayMode 決定是否需要重新取得詳細資料
        const needDetail = this.displayMode === 3 || this.displayMode === 4;
        
        apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetCategoryData?CId=${this.categoryId}&IncludePost=true&PostDetail=${needDetail}&locale=${backendLocale}`;
        response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得文章資料，清空資料');
          this.allItems = [];
          return;
        }
        
        const categoryWithPosts = await response.json();
        
        // 處理文章資料
        if (categoryWithPosts.Posts && Array.isArray(categoryWithPosts.Posts)) {
          this.processPostsData(categoryWithPosts.Posts);
        } else {
          this.allItems = [];
        }
        
      } catch (error) {
        console.error('載入分類資料失敗:', error);
        this.categoryTitle = '';
        this.allItems = [];
      }
    },

    // 根據 displayMode 設定每頁項目數
    setItemsPerPage() {
      switch (this.displayMode) {
        case 1: // 一般列表
          this.itemsPerPage = 10;
          break;
        case 2: // 圖文列表
          this.itemsPerPage = 6;
          break;
        case 3: // 問與答
          this.itemsPerPage = 10;
          break;
        case 4: // 圖文列表(直接顯示內文) - 不分頁
          this.itemsPerPage = 999999;
          break;
        default:
          this.itemsPerPage = 10;
      }
    },

    // 處理文章資料
    processPostsData(posts) {
      this.allItems = [];
      
      switch (this.displayMode) {
        case 1: // 一般列表 (NewsList)
          this.allItems = posts.map((post, index) => ({
            id: post.pId,
            time: this.formatDate(post.createTime),
            title: post.title,
            to: post.type === 2 ? post.url : `/Post/${post.pId}`,
            isExternal: post.type === 2,
            target: (post.type === 2 && post.blank) ? '_blank' : '_self'
          }));
          break;
          
        case 2: // 圖文列表 (ActivityList)
          this.allItems = posts.map((post, index) => ({
            id: post.pId,
            title: post.title,
            time: this.formatDate(post.createTime),
            to: post.type === 2 ? post.url : `/Post/${post.pId}`,
            isExternal: post.type === 2,
            target: (post.type === 2 && post.blank) ? '_blank' : '_self',
            src: post.image ? `${this.$store.state.src}${this.$store.state.subDirectory}${post.image}` : require('/public/img/img_1.png')
          }));
          break;
          
        case 3: // 問與答 (Faq)
          this.allItems = posts.map((post, index) => ({
            id: post.pId,
            question: post.title,
            answer: post.content || post.simpleContent || ''
          }));
          break;
          
        case 4: // 圖文列表(直接顯示內文) (ActivityList_2)
          this.allItems = posts.map((post, index) => ({
            id: post.pId,
            title: post.title,
            text: post.content || post.simpleContent || '',
            src: post.image ? `${this.$store.state.src}${this.$store.state.subDirectory}${post.image}` : require('/public/img/img_1.png'),
            hasBg: !!post.image // 有圖片才有背景
          }));
          break;
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}/${month}/${day}`;
    },

    // 分頁變更
    onPageChange(page) {
      this.currentPage = page;
      // 滾動到頁面頂部
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    // FAQ: 切換答案顯示
    toggleAnswer(id) {
      this.isAnswerOpen = this.isAnswerOpen === id ? null : id;
    },

    // DisplayMode 4: 檢查裝置
    checkDevice() {
      this.isMobile = window.innerWidth < 768.98;
    }
  },

}

</script>
